import $ from '@ali/tarzan-zepto';
import BaseUI from '../../../component/baseui';
import tpl from './tpl.html';
import util from '../../../lib/util.js';

import './style.scss';

const clickType = util.isPC() ? 'click' : 'tap';

const LOG_C = 'knowledge';
let app = null;
/**
 * 知识点最大高度，大于这个高度展示"展开"
 * @type {number}
 */
const MAX_HEIGHT = 105;
/**
 * 是否需要展示"展开"
 * @param $node
 * @returns {boolean}
 * @private
 */

function shouldShowMore($node) {
  let showmore = false;
  // node里图片数量大于1，直接返回true
  if ($node.find('img').length > 1) {
    showmore = true;
  } else {
    // 创建一个clone阶段，append到body上，计算总高度，算完remove掉
    const $nodeCopy = $node.clone();
    const $wrap = $('<div class="m-knowledge-calheight-layer"></div>');
    $wrap.append($nodeCopy);
    $('.m-alicare').append($wrap);
    // 判断copy节点的高度是否大于阈值
    const $knowledge = $nodeCopy.find('.knowledge');
    if ($knowledge.height() > MAX_HEIGHT) {
      showmore = true;
    }
    $wrap.remove();
  }
  return showmore;
}

/**
 * 点击查看更多，弹起浮层
 * @param ev
 */
function toggleKnowledge($dom) {
  const param = {
    name: 'knowledge',
    content: $dom.find('.knowledge').html(),
  };
  const $node = $(BaseUI.slideUp(param));
  $('.m-alicare').append($node);
  app.log.send({
    c: LOG_C,
    d: 'more',
  });

  function removeKnowledge() {
    app.log.send({
      c: LOG_C,
      d: 'hide',
    });
    $node.find('.J_Mask').hide().parent().addClass('slide-out-to-bottom');
    setTimeout(() => {
      $node.remove();
    }, 500);
  }

  $node.find('.J_Toggle').on(clickType, removeKnowledge);
  $node.find('.J_Mask').on('touchmove', (ev) => {
    ev.preventDefault();
  });
  $node.find('.J_Mask').on('swipeDown', removeKnowledge);
  $node.find('.J_Mask').on(clickType, removeKnowledge);

  $node.find('.J_Sub').on(clickType, (ev) => {
    const $target = $(ev.currentTarget);
    const text = $target.text();
    app.view.footer.submit(text);
    removeKnowledge();
  });
}

/**
 * 展示知识点评价
 */
function showRate(data, FEEDBACK) {
  app.appendMessage({
    type: 'feedback',
    body: Object.assign({}, FEEDBACK, { chatUuid: data.chatUuid }),
  });
}

function bindEvents(data, $node) {
  $node.find('.J_More').on(clickType, () => toggleKnowledge($node, data));
  $node.find('a').on(clickType, (ev) => {
    ev.preventDefault();
    const $target = $(ev.currentTarget);
    app.util.openWindow($target.attr('href'));
    app.log.send({
      c: LOG_C,
      d: 'link',
    });
  });
  $node.find('.J_Sub').on(clickType, (ev) => {
    const $target = $(ev.currentTarget);
    const text = $target.text();
    app.view.footer.submit(text);
  });
}

export default function knowledge(data) {
  app = this;
  const FEEDBACK = { button: [{ action: { intentId: '487', source: 'event' } }, { action: { intentId: '445', source: 'event' } }], text: app.util.lang.get('FEEDBACK:QUESTION'), isKnowledge: true };
  if (data.text) {
    data.text = data.text.replace(/&nbsp;/ig, ' ');
  }

  data.more = app.util.lang.get('BUTTON:MORE');
  data.suggest = app.util.lang.get('ROBOT:RECOMMEND');
  const param = {
    name: 'knowledge',
    type: 'text',
    mid: data.mid,
    content: tpl.render(data),
  };
  const $node = $(BaseUI.msg(param));
  // 有子知识
  const showMore = shouldShowMore($node);
  if (showMore) {
    $node.find('.J_More').css('display', 'inline-block');
  }
  /**
   * 需要展示评价
   * 1、实时问答里needEval是true
   * 2、历史消息里有feedback（用户评价过）
   */
  showRate(data, FEEDBACK);
  bindEvents(data, $node);
  return {
    // 插件返回的结果
    body: $node,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/knowledge/index.js